<template>
  <div>
    <h1>Collaborators</h1>
      <div class="horizontal-scroll">
        <div class="collaborator container-fluid">
            <div class="description">
              <a href="https://www.imagestrat.com/">
                <img src="../assets/collaborator-logos/Imagestrat Logo RGB.webp">
              </a>
              <p>ImageStrat Pty Ltd</p>
              <p class="description-text">Specialists in borehole image processing and interpretation.</p>
            </div>
        </div>
        <div class="collaborator container-fluid">
            <div class="description">
              <a href="https://www.basinscope.com.au/">
                <img src="../assets/collaborator-logos/Basin Scope Logo.webp">
              </a>
              <p>Basin Scope Consulting</p>
              <p class="description-text">Experts in structural geology and tectonics of sedimentary basins.</p>
            </div>
        </div>
    </div>
  </div>
  <!-- <div>
    <h1>Collaborators</h1>
    <div class="collab-div">
      <b-carousel
        v-model="slide"
        :interval="3500"
        controls
        indicators
        img-height="250"
        img-width="300"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide img-blank>
          <div class="container-fluid">
            <b-card>
              <b-card-text>
                <a href="https://www.imagestrat.com/"><img src="../assets/collaborator-logos/Imagestrat Logo RGB.webp"></a>
                <p>ImageStrat Pty Ltd</p>
                <p>Specialists in borehole image processing and interpretation.</p>
              </b-card-text>
            </b-card>
          </div>
        </b-carousel-slide>

        <b-carousel-slide img-blank>
          <div class="container-fluid">
            <b-card>
              <b-card-text>
                <a href="https://www.basinscope.com.au/"><img src="../assets/collaborator-logos/Basin Scope Logo.webp" alt="Logo"></a>
                <p>Basin Scope Consulting</p>
                <p>Experts in structural geology and tectonics of sedimentary basins.</p>
              </b-card-text>
            </b-card>
          </div>
        </b-carousel-slide>
      </b-carousel>
    </div>
  </div> -->
</template>

<script>
export default {
  name: 'Collaborators',
  data(){
    return {
      // slide: 0,
      // sliding: null
    };
  },
  methods: {
    // onSlideStart(slide) {
    //   this.sliding = true
    // },
    // onSlideEnd(slide) {
    //   this.sliding = false
    // }
  },
  mounted(){
    var item = document.getElementsByClassName('horizontal-scroll')[0];

    item.addEventListener('wheel', function(e) {
      e.preventDefault();
      if (e.deltaY > 0) item.scrollLeft += 100;
      else item.scrollLeft -= 100;
    });
  }
}
</script>

<style scoped>
h1, p {
  color: white;
}

h1 {
  margin-bottom: 2rem;
}

.horizontal-scroll {
    overflow-x:auto;
    white-space: nowrap;
    width: 80%;
    margin: 0 auto;
    padding: 1rem;
    background-color: rgba(0,0,0,0.3);
}

.horizontal-scroll::-webkit-scrollbar { 
    /* display: none;  */
    height: 4px;
    width: 4px;
    background: gray;
}

.horizontal-scroll::-webkit-scrollbar-thumb:horizontal{
        background: rgba(0, 0, 0, 0.514);
        border-radius: 10px;
    }

.collaborator {
    width: 50%;
    border-radius: 10px;
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    box-sizing: border-box;
}

.collaborator img {
    max-width: 80%;
    max-height: 5rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.description {
    white-space: normal;
}

.description-text {
    font-size: 1rem;
}

@media only screen and (max-width: 600px) {
  .collaborator {
    width: 100%;
  }
}
/* .collab-div {
  text-align: center;
}

.carousel {
  max-width: 70%;
  margin: 0 auto;
} */

/* .card {
  width: 300px;
  height: 200px;
} */

/* .card p {
  color: black;
}

img {
  max-width: 50%;
  margin-bottom: 2rem;
} */
/* 
.img .img-fluid .w-100 {
  width: 50% !important;
} */

/* @media only screen and (max-width: 600px) {
  .card {
    height: 230px;
    width: 230px;
  }

  section {
    padding-left: 10px;
    padding-right: 10px;
  }

  img {
    max-width: 80%;
  }
} */
</style>